var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { Subaudience } from '@square/dashboard-protos/models/squareup/precog/v2/common';
const CDP_EVENT_NAME = 'fnb_catalog_template';
let CatalogTemplatesService = (_dec = computed('_eligibility.eligible'), _class = class CatalogTemplatesService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantSubaudience", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "_eligibility", _descriptor4, this);
  }
  /**
   * Whether the user is eligible for the catalog templates experiment
   */
  get isEligible() {
    return this._eligibility ?? false;
  }
  async loadEligibility() {
    if (this._eligibility !== null) {
      return this._eligibility;
    }

    // V0 is only for en-us users to limit template translation scope
    if (this.userInfo.languageCode.toLowerCase() !== 'en-us' || this.userInfo.browserLanguage.toLowerCase().split('-')[0] !== 'en') {
      this._eligibility = false;
      return this._eligibility;
    }
    try {
      const subaudience = await this.merchantSubaudience.setup();
      const isEligibleSubaudience = subaudience && [Subaudience.SUBAUDIENCE_COMPLEX_QSR, Subaudience.SUBAUDIENCE_SIMPLE_QSR, Subaudience.SUBAUDIENCE_FSR, Subaudience.SUBAUDIENCE_BAR_BREWERY_LOUNGE].includes(subaudience);
      if (!isEligibleSubaudience) {
        this._eligibility = false;
        return this._eligibility;
      }
      this._eligibility = true;
      return this._eligibility;
    } catch {
      this._eligibility = false;
      return this._eligibility;
    }
  }
  clearEligibilityCache() {
    this._eligibility = null;
  }
  trackClickFromActionsMenu() {
    this.dataApi.track('click_feature', {
      feature: 'Catalog Templates',
      name: CDP_EVENT_NAME,
      eventDescription: 'User clicked Catalog Templates from actions menu'
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantSubaudience", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_eligibility", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isEligible", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isEligible"), _class.prototype), _class);
export { CatalogTemplatesService as default };